import { render } from "./BreadcrumbsNav.vue?vue&type=template&id=a725ebe4&scoped=true"
import script from "./BreadcrumbsNav.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsNav.vue?vue&type=script&lang=js"

import "./BreadcrumbsNav.vue?vue&type=style&index=0&id=a725ebe4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a725ebe4"]])

export default __exports__